import * as React from 'react';

import { Button, ButtonTheme } from '@cian/button-component';
import { OutsideClick } from '@cian/outside-click-component';
import { mergeStyles } from '@cian/utils';

import { LoginMotivationPopup } from '../../common/components/login_motivation_popup';
import { AdaptiveLikeButton } from '../../common/components/menu/adaptiveLikeButton';
import { ReportPopup } from '../../common/components/menu/more/report_popup';
import { PushSubscription } from '../../common/components/push_subscription';
import { Buttons } from '../../offer-card/components/buttons';

import * as buttonsStyles from '../../offer-card/components/buttons/index.css';
import * as styles from './TopButtons.css';

/**
 * Блок кнопок для футера царь-карточки
 *
 * В отличие от базовой версии (Buttons) умеет схлопывать кнопку Избранного (AdaptiveLikeButton) на узких экранах
 * Также убрана кнопка "Подробнее", так как переехала в блок описания (TopDescription)
 */
export class TopButtons extends Buttons {
  public render() {
    const { containerClassName } = this.props;

    return (
      <div onClick={e => e.stopPropagation()} className={containerClassName || ''}>
        { this.renderPhoneButton() }
        { this.renderLikeButton() }
        { this.renderReport() }
        { this.renderCallBack() }
        { this.renderMap() }
        { this.renderHideButton() }
        { this.renderMore() }
      </div>
    );
  }

  protected renderReport() {
    const {
      buttonClassName,
      complaintsHelpers: {
        sendComplaintFeedback,
        statusChanger,
        complaintsFormStatus,
      },
    } = this.props;
    const { user } = this.context;
    const { isReportActive } = this.state;

    return (
      <div {...mergeStyles([
        buttonClassName,
        styles['report-button'],
      ])}>
        <div title="Пожаловаться на объявление">
          <Button
            {...mergeStyles(
              buttonsStyles['report-button'],
              isReportActive && buttonsStyles['button-active'],
              styles['report-button'],
              styles['report-button--top'],
            )}
            theme={ButtonTheme.Ghost}
            onClick={this.handleReportButtonClick}
          >
            Пожаловаться
          </Button>
        </div>
        {isReportActive && (
          <div {...mergeStyles(
            buttonsStyles['popup-container'],
            buttonsStyles['popup-container--big'],
          )}>
            <ReportPopup
              onClose={this.handleReportClose}
              sendComplaintFeedback={sendComplaintFeedback}
              complaintsFormStatus={complaintsFormStatus}
              statusChanger={statusChanger}
              userEmail={user && user.isAuthenticated ? user.email : ''}
            />
          </div>
        )}
      </div>
    );
  }

  protected renderMore() {
    const { buttonClassName, dynamicButtonClassName } = this.props;
    const { isMorePopupOpen } = this.state;

    return (
      <div {...mergeStyles([
        buttonClassName,
        styles['more-button'],
      ])}>
        <OutsideClick onOutsideClick={this.handleMorePopupClose}>
          <div title="Ещё">
            <Button
              {...mergeStyles(
                buttonsStyles['more-button'],
                isMorePopupOpen && buttonsStyles['button-active'],
                this.isButtonHidden() && dynamicButtonClassName,
              )}
              theme={ButtonTheme.Ghost}
              onClick={this.handleMoreClick}
            />
          </div>
          <div className={buttonsStyles['popup-container']}>
            {isMorePopupOpen && this.renderMorePopup()}
          </div>
        </OutsideClick>
      </div>
    );
  }

  protected renderLikeButton() {
    const { loginMotivationPopup } = this.context.api;
    const { offer, buttonClassName } = this.props;
    const { isPushSubscriptionPopupOpen } = this.state;

    return (
      <div
        {...mergeStyles([
          buttonClassName || '',
          buttonsStyles['like-container'],
        ])}
      >
        <AdaptiveLikeButton
          isActive={!!offer.isFavorite}
          buttonClassName={buttonsStyles['like-button']}
          toggleActivity={this.handleFavoriteClick}
        />
        <LoginMotivationPopup id={offer.id} {...loginMotivationPopup} isAdaptive/>
        <PushSubscription isOpen={isPushSubscriptionPopupOpen} />
      </div>
    );
  }
}
